import React from "react";

export default function Card({topIsSquare=false,children}){
  return <div css={`
      border-radius: ${topIsSquare ? 0 : 11}px ${topIsSquare ? 0 : 11}px 11px 11px;
      background: #FFF;
      padding:16px;
      box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25);`}
  >{children}
    </div>
}